const getInitialNumbers = function ({ url, symbols }) {
    return window
        .fetch(`${url}/info/en?intervals=D1&symbols=${symbols.join(',')}`)
        .then(response => {
            if (response.ok) {
                return response.json()
            }
        })
        .then(response => {
            return response.data.instruments.map(i => {
                if (i.tradable) {
                    return {
                        code: i.code,
                        name: i.name.split('/')[0],
                        price: i.rate,
                        close: i.interval.D1.c,
                        percentChange: i.interval.D1.p.toFixed(2)
                    }
                }
            })
        })
}

export default {
    getInitialNumbers
}
